// Fachada de métricas do painel — métodos do repo (ver core.ts).
import { panelMetricsRepo } from './core';

export type {
  NegotiationLeadRow,
  SaleByCardRow,
  StaleLeadRow,
} from '@modules/panelMetrics';

export const countLeads                 = panelMetricsRepo.countLeads;
export const countMeetings              = panelMetricsRepo.countMeetings;
export const countUserMeetings          = panelMetricsRepo.countUserMeetings;
export const countActiveCards           = panelMetricsRepo.countActiveCards;
export const countCommissions           = panelMetricsRepo.countCommissions;
export const countActivities            = panelMetricsRepo.countActivities;
export const countLostCards             = panelMetricsRepo.countLostCards;
export const listNegotiationLeads       = panelMetricsRepo.listNegotiationLeads;
export const listSalesLeadIds           = panelMetricsRepo.listSalesLeadIds;
export const listOpenLeads              = panelMetricsRepo.listOpenLeads;
export const listRecentActivityLeadIds  = panelMetricsRepo.listRecentActivityLeadIds;
export const listSalesByCardIds         = panelMetricsRepo.listSalesByCardIds;
